import {exeRequest} from '../utils/APIUtils'

export default {
get : async  (concessionnaireId, dates) => exeRequest(`/concessionnaires/${concessionnaireId}/terminaux?dateDebut=${dates.debut}&dateFin=${dates.fin}`, "GET"),
getSoldes : async  (concessionnaireId) => exeRequest(`/concessionnaires/${concessionnaireId}/terminaux/soldes`, "GET"),
getOperations : async  (terminalId, dates) => exeRequest(`/terminaux/${terminalId}/operations?dateDebut=${dates.debut}&dateFin=${dates.fin}`, "GET"),
getChiffreAffaires : async  (terminalId, dates) => exeRequest(`/terminaux/${terminalId}/chiffre-affaires?dateDebut=${dates.debut}&dateFin=${dates.fin}`, "GET")
}